import { Component, OnInit } from '@angular/core';
import {PartnerCounterService} from '../services/partner-counter.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Company} from '../../dto/company';
import {CompanyService} from '../services/company.service';
import {PartnerCounterCompany} from '../../dto/partnerCounter';
import * as moment from 'moment';


@Component({
  selector: 'app-partner-counter',
  templateUrl: './partner-counter.component.html',
  styleUrls: ['./partner-counter.component.css']
})
export class PartnerCounterComponent implements OnInit {

  constructor(
    private partnerCounterService: PartnerCounterService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  companyId: number;
  company: Company|null;
  isLoading = false;
  counters: PartnerCounterCompany|null;

  prevMonth: number;
  nextMonth: number;
  prevMonthYear: number;
  nextMonthYear: number;

  month: number;
  year: number;

  displayedColumns: string[] = ['month', 'year', 'code', 'numberOfActions', 'amount'];

  ngOnInit(): void {

    this.companyId = parseInt(this.route.snapshot.paramMap.get('companyId'));
    this.route.queryParams.subscribe((params: Params) => {
      let month = parseInt(params['month']);
      let year = parseInt(params['year']);

      const now = moment().toDate();
      if ( isNaN(month)) {
month = now.getMonth() + 1;
}
      if ( isNaN(year)) {
year = now.getFullYear();
}

      this.month = month;
      this.year = year;


      let prevMonth = month - 1;
      let prevMonthYear = year;
      if ( prevMonth === 0 ) {
        prevMonth = 12;
        prevMonthYear--;
      }
      this.prevMonth = prevMonth;
      this.prevMonthYear = prevMonthYear;

      let nextMonth = month + 1;
      let nextMonthYear = year;
      if ( nextMonth === 13 ) {
        nextMonth = 1;
        nextMonthYear++;
      }
      this.nextMonth = nextMonth;
      this.nextMonthYear =nextMonthYear;

      this.loadData();

    });

  }

  private loadData(): void {
    this.isLoading = true;
    this.companyService.get(this.companyId).subscribe(data => {
      this.company = data;

      this.partnerCounterService.getForCompany(this.company.id, this.year, this.month).subscribe(data => {
        this.counters = data;
        this.isLoading = false;
      });

    });
  }

  goToPrevMonth() {
    this.month -= 1;
    if ( this.month === 0) {
      this.month = 12;
      this.year--;
    }
    this.navToMonth();

  }


  private navToMonth() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: { month: this.month, year: this.year },
        queryParamsHandling: 'merge'
      });
  }


  goToNextMonth() {
    this.month += 1;
    if ( this.month === 13) {
      this.month = 1;
      this.year++;
    }

    this.navToMonth();
  }

  goToCreateInvoice() {
    this.router.navigate(
      ['create-invoice'],
      {
        relativeTo: this.route,
        queryParams: { month: this.month, year: this.year },
        queryParamsHandling: 'merge',
      }
    );
  }

  goToCompanyEdit() {
    this.router.navigate(['companies', this.companyId, 'edit']);
  }
}
